import React, {useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";

//redux:
import {useDispatch, useSelector} from "react-redux";
import {mediaItemPageActions} from "../../../redux/MediaItemPage/mediaItemRedux";

//components:
import {CustomTooltip} from "../../../widgets";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";

//helpers:
import {useTranslation} from "react-i18next";
import {sortHits} from "../MediaDashboardLogic";

const MediaPageSearchBar = ({
    setShowSuggestion,
    setNodeAppearances,
    setShowModal,
    resetTimeline,
    currentRefinement,
    refine,
    searching,
}) => {
    const {t} = useTranslation();
    const [busyFetching, setBusyFetching] = useState(false);
    const [inputIsFocused, setInputIsFocused] = useState(false);
    const [lastSearched, setLastSearched] = useState("");
    const [currentValue, setCurrentValue] = useState("");
    const [selectedResult, setSelectedResult] = useState(null);

    //redux:
    //actions:
    const dispatch = useDispatch();
    //store:
    const {isConceptualSearch = false} = useSelector(state => state.mediaItemPage);

    const onSearch = () => {
        const trimmedValue = currentValue.replace(/\s\s+/g, " ").trim();

        if (!busyFetching && trimmedValue && trimmedValue !== lastSearched) {
            //debounce:
            setBusyFetching(true);
            setTimeout(() => {
                setBusyFetching(false);
            }, 1500);
            setNodeAppearances([]);

            setLastSearched(trimmedValue);
            dispatch(mediaItemPageActions.setIsConceptualSearch(false));
            refine(trimmedValue);
        }
    };

    useEffect(() => {
        if (!isConceptualSearch) setLastSearched(currentRefinement);
        setCurrentValue(currentRefinement);
    }, [currentRefinement, isConceptualSearch]);

    return (
        <div className={`videoSearchBar ${inputIsFocused ? "active" : ""}`}>
            {/* <div > */}
            <div className="input-group-prepend w-40px">
                {searching ? (
                    <CircularProgress
                        style={{width: "20px", height: "20px"}}
                        className="ml-2 text-muted m-auto cursor-pointer text-hover-white font-size-1_8rem"
                    />
                ) : (
                    <SearchIcon
                        className="text-muted m-auto cursor-pointer text-hover-white font-size-1_8rem"
                        onClick={() => {
                            onSearch();
                        }}
                    />
                )}
            </div>
            <input
                onFocus={() => setInputIsFocused(true)}
                onBlur={() => setInputIsFocused(false)}
                type="text"
                value={currentValue.replaceAll('"', "")}
                onChange={e => {
                    const value = e.target.value.replace(/\s\s+/g, " ");

                    if (!value) {
                        setShowSuggestion(false);
                        refine("");
                        setLastSearched("");
                    }
                    setCurrentValue(value);
                }}
                placeholder={t("VIDEOPAGE.SEARCHBAR.PLACEHOLDER")}
                onKeyDown={e => {
                    if (e.key === "Enter") {
                        onSearch();
                        setSelectedResult(null);
                    }
                }}
            />
            <CloseIcon
                className="text-muted text-hover-white cursor-pointer z-index-2"
                onClick={() => {
                    setShowSuggestion(false);
                    refine("");
                    setCurrentValue("");
                    resetTimeline();
                    setSelectedResult(null);
                }}
            />
            <CustomTooltip
                config={{
                    text: t("INFOMODAL.TOOLTIP.KNOW_MORE"),
                    placement: "top",
                }}
            >
                <div className="pulse pulse-primary pulse-icon" onClick={() => setShowModal(true)}>
                    <HelpOutlineIcon className="text-muted" />
                    <span className="pulse-ring text-primary" />
                    <span className="pulse-ring text-primary" />
                    <span className="pulse-ring text-primary" />
                    <span className="pulse-ring text-primary" />
                </div>
            </CustomTooltip>
            {/* SUGGESTIONS: */}
            {/* </div> */}
        </div>
    );
};

MediaPageSearchBar.propTypes = {
    setShowSuggestion: PropTypes.func,
    setNodeAppearances: PropTypes.func,
    showSuggestion: PropTypes.bool,
    timelineHighlight: PropTypes.string,
    handleMatchClick: PropTypes.func,
};

export default MediaPageSearchBar;
